// baseNode.js
// Clean, professional node design

import { useState } from "react";
import { Handle, Position } from "reactflow";

export const BaseNode = ({ id, data, config }) => {
  const [dimensions, setDimensions] = useState(
    config.defaultSize || { width: 200, height: 80 }
  );

  const {
    title,
    inputs = [],
    outputs = [],
    fields = [],
    color = "#3b82f6",
    icon = null,
  } = config;

  const nodeStyle = {
    minWidth: `${dimensions.width}px`,
    minHeight: `${dimensions.height}px`,
    background: "#ffffff",
    border: `1px solid #e2e8f0`,
    borderLeft: `3px solid ${color}`,
    borderRadius: "8px",
    padding: "14px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    transition: "box-shadow 0.15s ease",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: fields.length > 0 ? "12px" : "0",
    paddingBottom: fields.length > 0 ? "10px" : "0",
    borderBottom: fields.length > 0 ? "1px solid #f1f5f9" : "none",
  };

  const titleStyle = {
    fontSize: "13px",
    fontWeight: "600",
    color: "#1e293b",
    letterSpacing: "-0.01em",
  };

  const iconStyle = {
    fontSize: "16px",
    lineHeight: "1",
  };

  const handleStyle = {
    width: "10px",
    height: "10px",
    border: "2px solid #ffffff",
    background: color,
    borderRadius: "50%",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  };

  return (
    <div style={nodeStyle} className="base-node">
      {/* Input Handles */}
      {inputs.map((input, idx) => (
        <Handle
          key={`input-${idx}`}
          type="target"
          position={Position.Left}
          id={input.id}
          style={{
            ...handleStyle,
            top: fields.length > 0 ? `${40 + idx * 30}px` : `${50}%`,
            left: "-6px",
          }}
        />
      ))}

      {/* Node Header */}
      <div style={headerStyle}>
        {icon && <span style={iconStyle}>{icon}</span>}
        <span style={titleStyle}>{title}</span>
      </div>

      {/* Dynamic Fields */}
      {fields.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {fields.map((field, idx) => (
            <div key={`field-${idx}`}>
              {field.render(data, id, setDimensions)}
            </div>
          ))}
        </div>
      )}

      {/* Output Handles */}
      {outputs.map((output, idx) => (
        <Handle
          key={`output-${idx}`}
          type="source"
          position={Position.Right}
          id={output.id}
          style={{
            ...handleStyle,
            top: fields.length > 0 ? `${40 + idx * 30}px` : `${50}%`,
            right: "-6px",
          }}
        />
      ))}
    </div>
  );
};
